import { defineComponent as p, openBlock as o, createElementBlock as l, mergeProps as u, unref as e, renderSlot as h, createElementVNode as n, createCommentVNode as A } from "vue";
import { useScalarIcon as g } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, f = { key: 1 }, k = { key: 2 }, v = { key: 3 }, w = { key: 4 }, H = { key: 5 }, L = {
  name: "ScalarIconArrowClockwise"
}, V = /* @__PURE__ */ p({
  ...L,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: a } = g(s);
    return (i, t) => (o(), l("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      h(i.$slots, "default"),
      e(a) === "bold" ? (o(), l("g", m, t[0] || (t[0] = [
        n("path", { d: "M244,56v48a12,12,0,0,1-12,12H184a12,12,0,1,1,0-24H201.1l-19-17.38c-.13-.12-.26-.24-.38-.37A76,76,0,1,0,127,204h1a75.53,75.53,0,0,0,52.15-20.72,12,12,0,0,1,16.49,17.45A99.45,99.45,0,0,1,128,228h-1.37A100,100,0,1,1,198.51,57.06L220,76.72V56a12,12,0,0,1,24,0Z" }, null, -1)
      ]))) : e(a) === "duotone" ? (o(), l("g", f, t[1] || (t[1] = [
        n("path", {
          d: "M216,128a88,88,0,1,1-88-88A88,88,0,0,1,216,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z" }, null, -1)
      ]))) : e(a) === "fill" ? (o(), l("g", k, t[2] || (t[2] = [
        n("path", { d: "M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1-5.66-13.66l17-17-10.55-9.65-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,1,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60l10.93,10L226.34,50.3A8,8,0,0,1,240,56Z" }, null, -1)
      ]))) : e(a) === "light" ? (o(), l("g", v, t[3] || (t[3] = [
        n("path", { d: "M238,56v48a6,6,0,0,1-6,6H184a6,6,0,0,1,0-12h32.55l-30.38-27.8c-.06-.06-.12-.13-.19-.19a82,82,0,1,0-1.7,117.65,6,6,0,0,1,8.24,8.73A93.46,93.46,0,0,1,128,222h-1.28A94,94,0,1,1,194.37,61.4L226,90.35V56a6,6,0,1,1,12,0Z" }, null, -1)
      ]))) : e(a) === "regular" ? (o(), l("g", w, t[4] || (t[4] = [
        n("path", { d: "M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z" }, null, -1)
      ]))) : e(a) === "thin" ? (o(), l("g", H, t[5] || (t[5] = [
        n("path", { d: "M236,56v48a4,4,0,0,1-4,4H184a4,4,0,0,1,0-8h37.7L187.53,68.69l-.13-.12a84,84,0,1,0-1.75,120.51,4,4,0,0,1,5.5,5.82A91.43,91.43,0,0,1,128,220h-1.26A92,92,0,1,1,193,62.84l35,32.05V56a4,4,0,1,1,8,0Z" }, null, -1)
      ]))) : A("", !0)
    ], 16));
  }
});
export {
  V as default
};
